export default __webpack_public_path__ + "static/media/bank.31122b22.svg";